import { Injectable } from "@angular/core";
import { UserPlatformDto } from "../../users/domain/user_platform_dto.entity";
import { LoginDto } from "./login_dto.entity";

@Injectable()
export abstract class LoginRepository {
  abstract login(data: LoginDto): Promise<string>;
  abstract renewToken(): Promise<string>;
  abstract getUser(): Promise<UserPlatformDto | null>;
  abstract logout(): Promise<boolean>;
  abstract getVersion(): Promise<string>;

  abstract recover(username: string): Promise<boolean>;
  abstract recoverChangePassword(id: string, codigo: string, password: string): Promise<string>;
  abstract validateLinkNewMail(id: string, codigo: string): Promise<string>;
  abstract validateLinkRecovery(id: string, codigo: string): Promise<boolean>;
  abstract getSessionCode(): Promise<string | null>;
  abstract reSendCode(id: string): Promise<boolean>;
}
